/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useRef } from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import ParseContent from 'components/shared/ParseContent'

// Language
// import { getLanguage } from 'services/language'

// Libraries
import parse from 'html-react-parser'

import Joost from 'img/joost.png'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import RatingAlt from 'components/Reviews/RatingAlt'

// Elements
import HeroDefault from 'components/elements/HeroDefault'
import HeroDescription from 'components/elements/HeroDescription'
import BlockDefault from 'components/elements/BlockDefault'
import Quotation from 'components/Quotation'

const Contact = styled.div`
  background-color: ${(props) => props.theme.color.secondary};
  color: ${(props) => props.theme.color.text.light};
  border-radius: 25px;

  & a {
    color: ${(props) => props.theme.color.text.light};
  }

  & p:last-child {
    margin-bottom: 0;
  }
`

const Introduction = styled(ParseContent)`
  font-weight: ${(props) => props.theme.font.weight.s};

  & strong {
    font-weight: ${(props) => props.theme.font.weight.xl};
  }
`

const Stripe = styled.div`
  background-color: ${(props) => props.theme.color.background};
  height: 2px;
`

const OverLay = styled.div`
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  display: block;
  background: #000;
  opacity: 0.5;
  left: 0;
  z-index: 9;
`

const StyledBlockDefault = styled(BlockDefault)`
  position: relative;
  z-index: 9;
`

const StyledHeroDefault = styled(HeroDefault)`
  @media (min-width: 1200px) {
    min-height: 450px;
    max-height: 550px;
  }

  @media (max-width: 991px) {
    min-height: 350px;
    max-height: 450px;
  }
`

const Img = styled.img`
  width: 143px;
  height: auto;
  position: absolute;
  top: -1.46rem;
  left: 0.5rem;
`

export const pageQuery = graphql`
  query ($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      title
      path
      wordpress_id

      acf {
        banner {
          description
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 1920)
                openGraph: fluid(maxWidth: 1500, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }

        form {
          step_1_introduction
          step_1_contact
          step_2_introduction
          step_2_contact
        }

        form_fields {
          step_1 {
            title
            expand_description_in
            expand_description_out
            expaned_description
            from_title
            to_title
            button_next
            button_next_info
          }
          step_2 {
            title
            expand_description_in
            expand_description_out
            button_next
            button_next_info
          }
        }

        form_send {
          title
          description
          contact
          redirect_url {
            title
            url
          }
        }
      }

      yoast_meta {
        name
        content
        property
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { wordpress_id: wordPressId, path, yoast_meta: yoast, acf },
  },
}) => {
  const formId = wordPressId === 287 ? 2 : 3
  const [step, setStep] = useState(1)
  const [status, setStatus] = useState('')
  const [loaded, setLoaded] = useState(false)
  const start = useRef(null)

  const setStepLocal = (value) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(`quotation-${formId}-step`, value)
    }

    setStep(value)
  }

  useEffect(() => {
    if (!loaded && typeof localStorage !== 'undefined') {
      const storageStep = localStorage.getItem(`quotation-${formId}-step`)

      if (storageStep) {
        setStep(storageStep)
      }
    } else if (start && typeof window !== 'undefined') {
      window.scrollTo(0, start.current.offsetTop)
    }

    setLoaded(true)
  }, [step])

  return (
    <Layout noFooter>
      <SEO
        yoast={yoast}
        path={path}
        image={{
          url:
            acf.banner.image.localFile &&
            acf.banner.image.localFile.childImageSharp.openGraph.src,
        }}
      />

      {status === 'done' && (
        <div className="container py-5 mt-5">
          <BlockDefault className="my-5">
            <div className="pl-lg-5 py-lg-5">
              <div className="row">
                <div className="col-lg-8">{parse(acf.form_send.title)}</div>
                <div className="col-lg-4 pl-5">
                  <div className="mr-lg-n3">
                    <Contact className="py-3 px-4 mr-lg-n5">
                      {parse(acf.form_send.contact)}
                    </Contact>
                  </div>
                </div>
              </div>
              <ParseContent
                className="mt-5"
                content={acf.form_send.description}
              />
            </div>
          </BlockDefault>
        </div>
      )}

      {status !== 'done' && (
        <>
          <section>
            <StyledHeroDefault small image={acf.banner.image}>
              <HeroDescription className="d-flex align-items-center justify-content-end h-100">
                {parse(acf.banner.description)}
              </HeroDescription>
            </StyledHeroDefault>
          </section>

          <section ref={start} className="mt-n5 pb-5">
            <div className="container mt-n5">
              <div className="row">
                <div className="col-lg-12 mt-n5">
                  <OverLay />
                  <StyledBlockDefault>
                    <div className="row">
                      <div className="col-md-8">
                        <Introduction
                          content={
                            parseFloat(step) === 1
                              ? acf.form.step_1_introduction
                              : acf.form.step_2_introduction
                          }
                        />
                      </div>
                      <div className="col-md-4 pl-lg-5 d-none d-md-block">
                        <div className="mr-md-n3">
                          <Contact className="py-3 px-4 mr-md-n5 mt-3 mt-md-0 position-relative">
                            <div>
                              {parse(
                                parseFloat(step) === 1
                                  ? acf.form.step_1_contact
                                  : acf.form.step_2_contact
                              )}
                            </div>
                          </Contact>
                        </div>
                      </div>
                    </div>
                    <Stripe className="mt-3 mt-lg-5" />
                    <div className="mt-5 position-relative">
                      <Quotation
                        id={formId}
                        fields={acf.form_fields}
                        fieldsSend={acf.form_send}
                        infoPageId={wordPressId}
                        step={step}
                        setStep={setStepLocal}
                        status={status}
                        setStatus={setStatus}
                      />
                    </div>
                    <div className="col-md-4 pl-lg-5 d-md-none">
                      <div className="mr-md-n3">
                        <Contact className="py-3 px-4 mr-md-n5 mt-3 mt-md-0">
                          {parse(
                            parseFloat(step) === 1
                              ? acf.form.step_1_contact
                              : acf.form.step_2_contact
                          )}
                        </Contact>
                      </div>
                    </div>
                  </StyledBlockDefault>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </Layout>
  )
}

export default PageTemplate
